<template>
    <div class="socials">
        <SocialNetworkInput
            v-if="isMobile && active !== null"
            :key="'current' + active"
            :social-network="active"
            :collapsible="false"
            v-model="profileInfo[active]"
            :is-active="true"
            :sn-error="errors[active]"
            @error="applyError(active, $event)"
        />
        <SocialNetworkInput
            v-for="network of networks"
            :key="network"
            :ref="'sni_' + network"
            :social-network="network"
            v-model="profileInfo[network]"
            :is-active="active === network"
            :is-mobile="isMobile"
            @click="clickHandler(network, $event)"
            @error="applyError(network, $event)"
        />
    </div>
</template>

<script>
import SocialNetworkInputv2 from './SocialNetworkInputv2';
import { mapGetters } from 'vuex';
export default {
    name: 'SocialNetworkInputs',
    data: () => ({
        profileInfo: null,
        errors: {},
        networks: ['vk', 'maxMessenger', 'telegram', 'ok', 'rutube', 'zen', 'yappy', 'tenchat', 'yt', 'tiktok'],
        active: null,
    }),
    components: {
        SocialNetworkInput: SocialNetworkInputv2,
    },
    props: {
        value: Object,
    },
    computed: {
        ...mapGetters(['isMobile']),
        calculatedNetworks() {
            return this.networks.filter((network) => !this.isMobile || this.active !== network);
        },
    },
    created() {
        this.profileInfo = this.value;
    },
    watch: {
        value() {
            this.profileInfo = this.value;
        },
    },
    methods: {
        hasError(network) {
            return network !== null && this.errors[network] !== undefined && this.errors[network] !== '';
        },
        hasErrors() {
            return Object.values(this.errors).find((e) => e !== '');
        },
        switchNetwork(network) {
            if (this.active !== network) {
                this.active = network;
            } else {
                this.active = null;
            }
        },
        clickHandler(network) {
            if (!this.hasError(this.active)) {
                this.switchNetwork(network);
            }
        },
        apply() {
            if (this.hasErrors()) {
                return null;
            }
            this.active = null;
            return this.profileInfo;
        },
        applyError(network, error) {
            this.errors[network] = error;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/mrem';

.socials {
    display: flex;
    flex-wrap: wrap;
    margin-top: mrem(16);
    margin-bottom: mrem(12);

    @include on-desktop {
        margin-top: rem(16);
        margin-bottom: 0;
        justify-content: center;
    }
}
</style>
